import { request } from "./request.js";

export async function get(key) {
    return await request("/complaint", { key: key }, "POST");
}

export async function save(data) {
    return await request("/complaint/save", data, "POST");
}

export async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/complaint/list" + append, {}, "POST");
}

export async function checkupSave(data) {
    return await request("/checkup/complaint", data, "POST");
}
